<template>
  <v-menu bottom left min-width="200" offset-y
          origin="top right" transition="scale-transition">
    <template v-slot:activator="{ attrs, on }">
      <v-btn class="ml-2" min-width="0" text v-bind="attrs" v-on="on">
        <v-icon>mdi-account</v-icon>
      </v-btn>
    </template>
    <v-list :tile="false" flat nav>
      <template>
        <app-bar-item v-for="(p, i) in profile" :key="i" link>
          <v-divider v-if="p.divider" :key="`divider-${i}`"/>
          <v-list-item-content v-else>
            <v-list-item-title @click="logout()">{{ p.title }}</v-list-item-title>
          </v-list-item-content>
        </app-bar-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import {mapActions} from "vuex";
import {MapActions} from "../../../store/modules/auth/map-actions.auth";

export default {
  name: 'DefaultAccount',

  data: () => ({
    profile: [
      // { title: 'Perfil' },
      // {title: 'Configurações'},
      // {divider: true},
      {title: 'Sair'},
    ],
  }),
  methods: {
    ...mapActions(MapActions.NOME_MODULO, [MapActions.DESLOGAR_USUARIO]),
    logout() {
      this.deslogarUsuario(this);
    }
  }
}
</script>
